import { RxDragHandleDots2 as ReorderHandle } from 'react-icons/rx';

export const DndHandleTableCellContentRenderer = (): JSX.Element => (
  <div className="grow-0 pl-4">
    <ReorderHandle className="h-5 w-5 text-gray-600" />
  </div>
);
